module.exports = __webpack_public_path__ + "static/media/Meda - Sand_White.b8f6c13a.jpg";